// Dependencies
import React, { useEffect } from "react";

// Components
import ItemList from "../components/itemList";

const NestedList = (props) => {
  useEffect(() => {
    let openedElements = document.querySelectorAll(".opened");
    for (let i = 0; i < openedElements.length; i++) {
      let childrenOpenedElements = openedElements[i].children[0].children;
      if (childrenOpenedElements[i].length > 1) {
        childrenOpenedElements[i].children[1].children[0].classList.add(
          "rotate"
        );
      }

      for (let i = 0; i < childrenOpenedElements.length; i++) {
        childrenOpenedElements[i].classList.remove("hide");
      }
    }
  }, []);

  const _collapse = (event) => {
    let myCollection = event.currentTarget.parentElement.children;

    for (let i = 0; i < myCollection.length; i++) {
      if (myCollection[i].classList.contains("list")) {
        myCollection[i].classList.toggle("hide");
      } else {
        if (myCollection[i].classList.contains("noLast")) {
          myCollection[i].children[1].children[0].classList.toggle("rotate");
        }
      }
    }
  };

  const _goTo = (event, item) => {
    if (item.url && props.ownership) {
      event.stopPropagation();
      event.preventDefault();
      window.location.href = item.url;
    }
  };

  const newItemList = (item, first, index) => {
    if (item.descendants.length === 0) {
      return (
        <ul
          key={`${index}-a`}
          className={`list ${first === true ? "" : "hide"} last ${
            item.opened ? "opened" : ""
          }`}
        >
          <li className="level">
            <ItemList
              title={item.title}
              subtitle={item.subtitle}
              sublevels={
                item.descendants.length > 0 ? item.descendants.length : ""
              }
              documentsCount={item.documents_count}
              color={item.colour}
              classColor={props.classColor}
              goTo={(event) => _goTo(event, item)}
              action={(event) => {
                _collapse(event);
                props.action && props.action(item.id, item.url);
              }}
              lastItem={"last"}
            />
          </li>
        </ul>
      );
    }
    return (
      <ul
        key={`${index}-b`}
        className={`list ${
          props.forceClosed ? "" : first === true ? "opened" : "hide"
        }`}
      >
        <li className="level">
          <ItemList
            title={item.title}
            subtitle={item.subtitle}
            sublevels={
              item.descendants.length > 0 ? item.descendants.length : ""
            }
            color={item.colour}
            documentsCount={item.documents_count}
            classColor={props.classColor}
            action={(event) => _collapse(event)}
            goTo={(event) => _goTo(event, item)}
            lastItem={"noLast"}
          />

          {item.descendants.map((item, index) =>
            newItemList(item, false, index)
          )}
        </li>
      </ul>
    );
  };

  return props.data.map((descendant, index) =>
    newItemList(descendant, true, index)
  );
};

export default NestedList;
